// @flow
import { APICore } from './apiCore';
import config from '../../config';
import { buildQueryParams } from './search-shipments-kpis-request';

const api = new APICore();

const BASE_URL = config.DELIVERY_PERFORMANCE_ANALYTICS_URL;

const makeApiCall = (endpoint: string, query: Query | string): Promise<any> => {
    if (typeof query === 'string') {
        return api.get(`${BASE_URL}${endpoint}?${query}`, {}, {});
    }
    const queryParams = buildQueryParams(query);
    return api.get(`${BASE_URL}${endpoint}`, queryParams, {});
};

function getOnTimeShipments(query): any {
    const endpoint = '/on_time_shipments';
    return makeApiCall(endpoint, query);
}

function getLateShipments(query): any {
    const endpoint = '/late_shipments';
    return makeApiCall(endpoint, query);
}

function getEarlyShipments(query): any {
    const endpoint = '/early_shipments';
    return makeApiCall(endpoint, query);
}

function getDeliveryPerformance(query): any {
    const endpoint = '/delivery_performance';
    return makeApiCall(endpoint, query);
}

function getDeliveryPerformanceByTimeframe(query): any {
    const endpoint = '/delivery_performance_by_timeframe';
    return makeApiCall(endpoint, query);
}

export {
    getOnTimeShipments,
    getLateShipments,
    getEarlyShipments,
    getDeliveryPerformance,
    getDeliveryPerformanceByTimeframe,
};

